import { setTerm } from './helpers';

export const setUndergroundTravelType = setTerm('only_foot');
